import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { getClassFromInvitationCode, put_enrollClass } from "../../services/Class";
import useAuth from "../../hook/useAuth";
import Cookies from "js-cookie";
import { PleasewaitPopup } from "../../components/PleasewaitPopup";


export const ClassInvitation = () => {
    const { auth }: any = useAuth();
    const token = Cookies.get("token-elministry");
    const role = Cookies.get("role-elministry");
    const userId = Cookies.get("userId-elministry");
    const navigate = useNavigate();
    const location = useLocation();
    const { invitationcode } = useParams<{ invitationcode: string }>();
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get("email");
    const { invitationData } = location.state || {};
    const [classTitle, setClassTitle] = useState<string>("");
    const [courseName, setCourseName] = useState<string>("");
    const [instructorName, setInstructorName] = useState<string>("");
    const [isClassDataLoaded, setIsClassDataLoaded] = useState<boolean>(false);
    const [showPleaseWaitPopup, setShowPleaseWaitPopup] = useState<boolean>(false);
    const [userIsValid, setUserIsValid] = useState<boolean>(false);
    const [accoountNotExist, setAccountNotExist] = useState<boolean>(false);

    useEffect(() => {
        if (email) {
            setAccountNotExist(true);
            setIsClassDataLoaded(true);
        }
        else {
            if (!token) {
                navigate("/login", { replace: true });
            }
            else {
                setIsClassDataLoaded(false);
                if (role === "Learner" && invitationcode) {
                    if (invitationData) {
                        setClassTitle(invitationData?.title);
                        setCourseName(invitationData?.courseName);
                        setInstructorName(invitationData?.teacherName);
                        setUserIsValid(true);
                        setAccountNotExist(false);
                        setIsClassDataLoaded(true);
                    }
                    else {
                        getClassFromInvitationCode(invitationcode, Number(userId))
                            .then((data) => {
                                setClassTitle(data?.title);
                                setCourseName(data?.courseName);
                                setInstructorName(data?.teacherName);
                                setUserIsValid(true);
                                setAccountNotExist(false);
                                setIsClassDataLoaded(true);
                            })
                            .catch((error) => {
                                console.error(error);
                                setUserIsValid(false);
                                setAccountNotExist(false);
                                setIsClassDataLoaded(true);
                            })
                    }

                }
                else {
                    setUserIsValid(false);
                    setAccountNotExist(false);
                    setIsClassDataLoaded(true);
                }

            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invitationcode, email])

    const accpetInvitation = () => {
        setShowPleaseWaitPopup(true)
        put_enrollClass("Accepted", invitationcode || "", auth?.emailAddress, auth?.id)
            .then((data) => {
                setShowPleaseWaitPopup(false);
                navigate("/learner/dashboard");
            })
            .catch((error) => {
                console.error(error);
            })
    }

    const declineInvitatioin = () => {
        setShowPleaseWaitPopup(true)
        put_enrollClass("Rejected", invitationcode || "", auth?.emailAddress, auth?.id)
            .then((data) => {
                setShowPleaseWaitPopup(false);
                navigate("/learner/dashboard");
            })
            .catch((error) => {
                console.error(error);
            })
    }

    return (
        <>
            <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
                {
                    (isClassDataLoaded && userIsValid && !accoountNotExist) && (
                        <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-8">
                            {/* Header */}
                            <div className="text-center">
                                <h1 className="text-2xl font-bold text-gray-800">Class Invitation</h1>
                                <p className="text-gray-600 mt-2">
                                    You’ve been invited to join a class!
                                </p>
                            </div>

                            {/* Invitation Details */}
                            <div className="mt-6 bg-gray-100 rounded-xl p-4">
                                <h2 className="text-lg font-semibold text-gray-700 uppercase">📚 {classTitle}</h2>
                                <p className="text-sm text-gray-600 mt-1">
                                    Course: <span className="font-medium">{courseName}</span>
                                </p>
                                <p className="text-sm text-gray-600 mt-1">
                                    Instructor: <span className="font-medium">{instructorName}</span>
                                </p>

                            </div>

                            {/* Action Buttons */}
                            <div className="mt-8 flex gap-4">
                                <button
                                    className="w-1/2 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-md font-medium transition"
                                    onClick={() => accpetInvitation()}
                                >
                                    Accept
                                </button>
                                <button
                                    className="w-1/2 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-md font-medium transition"
                                    onClick={() => declineInvitatioin()}
                                >
                                    Decline
                                </button>
                            </div>

                            {/* Footer */}
                            <p className="text-xs text-gray-500 text-center mt-6">
                                By accepting, you agree to join the class.
                            </p>
                        </div>
                    )
                }

                {
                    (isClassDataLoaded && !userIsValid && !accoountNotExist) && (
                        <div className="w-full max-w-2xl bg-white rounded-2xl border border-gray-200 p-4 shadow-sm 0verflow-hidden">
                            <div className="p-8 sm:p-12">
                                <div className="flex items-start gap-6">
                                    {/* Illustration / icon */}
                                    <div className="flex-shrink-0">
                                        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center ring-1 ring-red-100">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-10 h-10 text-red-600"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 17h.01" />
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                                />
                                            </svg>
                                        </div>
                                    </div>


                                    {/* Text */}
                                    <div className="flex-1">
                                        <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">Invalid user</h1>
                                        <p className="mt-3 text-gray-600 leading-relaxed">
                                            The user with you trying to access this invitation link is invalid.
                                        </p>


                                        <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row sm:items-center gap-3 justify-between">


                                            <button
                                                onClick={() => navigate("/")}
                                                className="inline-flex items-center justify-center px-5 py-3 rounded-lg border border-gray-200 bg-primary text-sm font-medium text-white hover:bg-blue-700"
                                            >
                                                Go to homepage
                                            </button>


                                            <button
                                                onClick={() => navigate("/")}
                                                className="inline-flex items-center justify-center px-5 py-3 rounded-lg border border-gray-200 bg-white text-sm font-medium text-gray-700 h hover:bg-gray-200"
                                            >
                                                Contact support
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }


                {
                    (isClassDataLoaded && accoountNotExist) && (
                        <div className="w-full max-w-2xl bg-white rounded-2xl border border-gray-200 p-4 shadow-sm 0verflow-hidden">
                            <div className="p-8 sm:p-12">
                                <div className="flex items-start gap-6">
                                    {/* Illustration / icon */}
                                    <div className="flex-shrink-0">
                                        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center ring-1 ring-red-100">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-10 h-10 text-red-600"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 17h.01" />
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                                />
                                            </svg>
                                        </div>
                                    </div>


                                    {/* Text */}
                                    <div className="flex-1">
                                        <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">Account doesn't exist</h1>
                                        <p className="mt-3 text-gray-600 leading-relaxed">
                                            No account was found with this email. Please create a new account using this email and select the Learner role. Once you’ve logged in, you’ll be able to access this invitation link.
                                        </p>


                                        <div className="mt-6 w-full">


                                            <button
                                                onClick={() => navigate("/signup", {
                                                    state: {
                                                        emailForAccount: email
                                                    }
                                                })}
                                                className="w-full inline-flex items-center justify-center px-5 py-3 rounded-lg border border-gray-200 bg-primary text-sm font-medium text-white hover:bg-blue-700"
                                            >
                                                Sign Up
                                            </button>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }



                {
                    (!isClassDataLoaded) && (
                        <div className="flex flex-col items-center rounded-lg">
                            <div className="mb-4 h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                        </div>
                    )
                }

            </div>
            <PleasewaitPopup showPopup={showPleaseWaitPopup} />
        </>
    )
}